<template>
  <quill-editor
    @input="$emit('update:content', $event)"
    :options="options"
    :style="cssVars"
  />
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor';

export default {
  components: {
    quillEditor,
  },
  props: {
    content: String,
    minHeight: String,
  },
  data() {
    return {
      options: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],

              [{ list: 'ordered' }, { list: 'bullet' }],

              [{ header: [1, 2, 3, 4, 5, false] }],

              ['clean'],

              ['image', 'link'],

              [
                {
                  color: [
                    '#F00',
                    '#339933',
                    '#003300',
                    '#0b1a75',
                    '#000',
                    '#595959',
                    '#FFF',
                  ],
                },
              ],
            ],
          },
        },
      },
    };
  },
  computed: {
    cssVars() {
      return {
        '--ql-editor-min-height': `${this.minHeight}px`,
      };
    },
  },
};
</script>

<style>
.ql-editor {
  min-height: var(--ql-editor-min-height);
}
</style>
